<template>
  <div>
    <v-text-field
      :value="nombreCategoria"
      :label="label || 'Categoría (opcional)'"
      placeholder="Elegir categoría"
      readonly
      outlined
      :clearable="!!nombreCategoria"
      append-icon="mdi-chevron-right"
      @click="dialog = true"
      @click:append="dialog = true"
      @click:clear="removeCategoria"
    ></v-text-field>
    <categoria-picker
      v-model="dialog"
      :seleccionada="categoria"
      solo-hojas
      @select="setCategoriaRegister"
    ></categoria-picker>
  </div>
</template>

<script>
import CategoriaPicker from "@/components/categorias/CategoriaPicker.vue";

export default {
  name: "form.producto.categoria",
  components: {
    CategoriaPicker,
  },
  props: {
    producto: {
      type: Object,
      required: false,
    },
    categoria: {
      type: Object,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    nombreCategoria() {
      const c = this.categoria;
      if (!c || c.id == null || c.name === "SIN CATEGORIA") return "";
      return c.name;
    },
  },
  methods: {
    removeCategoria() {
      this.$emit("set_categoria", null);
    },
    setCategoriaRegister(cat) {
      this.$emit("set_categoria", cat);
    },
  },
};
</script>

<style lang="scss" scoped></style>
